export const selectCategoriesState = (state) => state.categories;

export const selectCategoriesById = (state) => state.categories.byId;

export const selectAllCategoriesIds = (state) => state.categories.allIds;

export const selectCategoriesItems = (state) => state.categories.items;

export const selectIsListLoading = (state) => state.categories.loading.list;

export const selectIsItemLoading = (state, id) => state.categories.loading.items[id] || false;

export const selectIsAnyLoading = (state) => {
    const { list, items } = state.categories.loading;
    return list || Object.values(items).some(loading => loading);
};

export const selectSubcategories = (state, parentId) => state.categories.subcategories?.[parentId];

export const selectSubcategoriesLoading = (state, parentId) => state.categories.loading?.subcategories?.[parentId] || false;

export const selectListError = (state) => state.categories.error.list;

export const selectItemError = (state, id) => state.categories.error.items[id] || null;

export const selectHasErrors = (state) => {
    const { list, items } = state.categories.error;
    return !!list || Object.values(items).some(error => error);
};

export const categoriesSelectors = {
    selectCategoriesState,
    selectCategoriesById,
    selectAllCategoriesIds,
    selectCategoriesItems,

    selectSubcategories,
    selectSubcategoriesLoading,

    selectIsListLoading,
    selectIsItemLoading,
    selectIsAnyLoading,

    selectListError,
    selectItemError,
    selectHasErrors,
};

export default categoriesSelectors;